import { Github, Linkedin, Instagram, Mail } from "lucide-react";
import "./SocialDock.css";

const OrcidIcon = (props) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>ORCID</title>
    <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zM7.369 4.378c.525 0 .947.431.947.947s-.422.947-.947.947a.95.95 0 0 1-.947-.947c0-.525.422-.947.947-.947zm-.722 3.038h1.444v10.041H6.647V7.416zm3.562 0h3.9c3.712 0 5.344 2.653 5.344 5.025 0 2.578-2.016 5.025-5.325 5.025h-3.919V7.416zm1.444 1.303v7.444h2.297c3.272 0 4.022-2.484 4.022-3.722 0-2.016-1.284-3.722-4.097-3.722h-2.222z" fill="currentColor" />
  </svg>
);

const socials = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/barham.farraj/",
    icon: Instagram,
    strokeWidth: 1.6,
  },
  {
    name: "GitHub",
    url: "https://github.com/Farraj007",
    icon: Github,
    strokeWidth: 1.6,
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/barham-farraj-258683147/",
    icon: Linkedin,
    strokeWidth: 1.6,
  },
  {
    name: "Email",
    url: "mailto:barhamfarraj@icloud.com",
    icon: Mail,
    strokeWidth: 1.6,
  },
  {
    name: "ORCID",
    url: "https://orcid.org/0009-0005-9450-4705",
    icon: OrcidIcon,
  },
];

const SocialDock = () => {
  return (
    <div className="social-dock" aria-label="Social links">
      {socials.map((social) => {
        const Icon = social.icon;
        return (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="dock-item"
            aria-label={social.name}
          >
            {Icon && (
              <Icon className="dock-icon" strokeWidth={social.strokeWidth} />
            )}
            <span className="dock-tooltip">{social.name}</span>
          </a>
        );
      })}
    </div>
  );
};

export default SocialDock;
